import Vue from 'vue';
import {Task as TaskModel} from '@/interfaces/TaskInterfaces';
import TaskColumnMixin from '@/mixins/TaskColumnMixin';
import {ViewStateType} from "@/enums/ViewStateType";
import {humanReadableRole} from "@/enums/userRolesEnum";

const MY_TASKS_TAB_ID = -1;

export default Vue.component('incoming-task-column', {
  name: 'IncomingTaskColumn',
  mixins: [TaskColumnMixin],
  data() {
    return {
      tabs: [] as any,
      focusedTab: MY_TASKS_TAB_ID
    }
  },
  computed: {
    taskUserId(): number {
      return this.$store.state.task.userIdInFocus;
    },
    taskUserIsLoggedInUser(): boolean {
      return this.taskUserId === this.$store.state.user.appUserId;
    },
    hasUnread(): boolean {
      return ((this as any).tasks as TaskModel[]).filter(task => !task.isRead && (task.assignedToAppUserId === this.taskUserId || this.taskUserIsLoggedInUser)).length > 0;
    },
    hasEmergency(): boolean {
      return ((this as any).tasks as TaskModel[]).filter(task => task.isEmergency && (task.assignedToAppUserId === this.taskUserId || this.taskUserIsLoggedInUser)).length > 0;
    }
  },
  created() {
    if ((this as any).$store.state.viewState[ViewStateType.INCOMING_TASKS_TAB_STATE]) {
      (this as any).focusedTab = (this as any).$store.state.viewState[ViewStateType.INCOMING_TASKS_TAB_STATE];
    }
    (this as any).tabs = [
      {
        id: MY_TASKS_TAB_ID,
        name: 'My Tasks',
        isFocused: (this).focusedTab === MY_TASKS_TAB_ID,
        visible: true,
        tasks: []
      },
      ...this.$store.state.user.roles.map((role: any) => {
        return { id: role.id, name: humanReadableRole(role.id), isFocused: (this).focusedTab === role.id, tasks: [] };
      })
    ];
    this.setIncomingTasks((this as any).tasks);
  },
  methods: {
    setTasks(newTasks: TaskModel[]) {
      // When the Mixin calls this, tabs have not yet been created so we do nothing.
      // Our created() will call our unique tasks
      // When watchers fire, tabs have been created so we need to pass along the task set
      if (this.tabs.length > 0) {
        this.setIncomingTasks(newTasks);
      }
    },
    setIncomingTasks(newTasks: TaskModel[]) {
      (this as any).loadEditingTasksState(newTasks);
      const map = new Map<number, any>();
      for (const tab of (this as any).tabs) {
        tab.tasks = [];
        tab.visible = this.taskUserIsLoggedInUser || tab.id === MY_TASKS_TAB_ID;
        map.set(tab.id, tab);
      }
      // Need to make sure we work with a copy or Vuex gets angry we're making changes without it.
      (this as any).ourTasks = newTasks.map((task: TaskModel) => {
        const oldTask = (this as any).ourTasks.find((oldTask: TaskModel) => oldTask.id === task.id);
        const toReturn = Object.assign({}, task);
        toReturn.isEditing = oldTask ? oldTask.isEditing : task.isEditing;
        // Put the task in the right place
        // todo Not sure what the requirements are for Expiring Tasks yet
        if (task.assignedToAppUserId === this.taskUserId) {
          map.get(MY_TASKS_TAB_ID).tasks.push(toReturn);
        } else if (this.taskUserIsLoggedInUser && map.get(task.assignedToSecurityRoleId!)) {
          map.get(task.assignedToSecurityRoleId!).tasks.push(toReturn);
        }
        return toReturn;
      });
      const myTab = map.get(MY_TASKS_TAB_ID);
      myTab.unreadCount = myTab.tasks.filter((task: TaskModel) => !task.isRead).length;
      if (!this.taskUserIsLoggedInUser) {
        this.focusOnTab(myTab);
      }
    },
    async toggleEdit(task: TaskModel) {
      task.isEditing = !task.isEditing;
      // Hack to get it to go
      (this as any).ourTasks = (this as any).ourTasks.map((task: any) => task);
      if (!task.isRead && task.assignedToAppUserId === this.$store.state.user.appUserId) {
        await (this as any).markRead(task);
      }
      (this as any).storeEditingTaskState(task);
    },
    focusOnTab(tab: any) {
      for (const aTab of (this as any).tabs) {
        aTab.isFocused = false;
      }
      tab.isFocused = true;
      this.$store.dispatch('viewState/updateViewState',
        {name: ViewStateType.INCOMING_TASKS_TAB_STATE, value: JSON.parse(JSON.stringify(tab.id))});
    },
    getTasksForReorder() : TaskModel[] {
      return this.tabs.filter((tab : any) => tab.isFocused)[0].tasks;
    },
    getColumnAssignee() {
      const tab = this.tabs.filter((tab : any) => tab.isFocused)[0];
      if (tab.id === MY_TASKS_TAB_ID) {
        return {assignedToAppUserId : (this as any).$store.state.user.appUserId, assignedToSecurityRoleId : null};
      } else {
        return {assignedToAppUserId : null, assignedToSecurityRoleId : tab.id};
      }
    },
  }
});



// WEBPACK FOOTER //
// ./src/componentsReusable/tasks/column/IncomingTaskColumn.ts